import { useList } from "@refinedev/core";
import { Link } from "react-router-dom";
import { Plus, Edit } from "lucide-react";
import { PageHeader } from "@/components/forms/PageHeader";
import { ToggleActivo } from "@/components/forms/ToggleActivo";

interface Tienda {
  id: string;
  codigo: string;
  nombre: string;
  marca: string;
  tipo_producto: string;
  ciudad: string;
  activo: boolean;
}

export function TiendasPage() {
  const { data, isLoading } = useList<Tienda>({ resource: "tiendas" });

  return (
    <div>
      <PageHeader
        title="Tiendas"
        subtitle="Puntos de venta"
        actions={
          <Link to="/admin/tiendas/nueva" className="btn-primary inline-flex items-center gap-2">
            <Plus className="size-4" /> Nueva tienda
          </Link>
        }
      />

      {isLoading ? (
        <div className="card p-8 text-center text-fg-muted">Cargando...</div>
      ) : (
        <ul className="space-y-2">
          {data?.data.map((t) => (
            <li key={t.id} className="card p-4 flex items-center gap-3">
              <div className="flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-medium">{t.nombre}</span>
                  <span className="text-xs px-2 py-0.5 bg-bg rounded-pill text-fg-muted">
                    {t.codigo}
                  </span>
                  <span className="text-xs px-2 py-0.5 bg-brand/10 text-brand rounded-pill">
                    {t.tipo_producto === "celular" ? "📱 Celulares" : "🏍 Motos"}
                  </span>
                </div>
                <p className="text-sm text-fg-muted">
                  {t.marca} · {t.ciudad}
                </p>
              </div>
              {!t.activo && <span className="text-xs text-error">Inactiva</span>}
              <ToggleActivo
                resource="tiendas"
                id={t.id}
                activo={t.activo}
                confirmarTexto={`¿Desactivar tienda "${t.nombre}"? Los operadores no podrán registrar ventas mientras esté inactiva.`}
              />
              <Link
                to={`/admin/tiendas/${t.id}/editar`}
                className="p-2 rounded-md hover:bg-bg text-fg-secondary"
                aria-label="Editar"
              >
                <Edit className="size-4" />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
